
import { namespace } from 'vuex-class';
import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
import rest from "@/rest";
// components
import CompAudioPlayerWithSubtitles from '../ExerciseComponents/CompAudioPlayerWithSubtitles.vue';
import MarkdownEditor from '../Shared/MarkdownEditor.vue';
// interfaces
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { ExerciseVM } from '@/interfaces/ExerciseVM';

const globals = namespace("globals");

@Component({
    components: {
      CompAudioPlayerWithSubtitles,
      MarkdownEditor
    }
  })
  export default class TtsAudioElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showMarkdownEditor = false;

  mounted() {}

  openMarkdownEditor() {
    this.showMarkdownEditor = true;
  }

  }
  